module.exports = __webpack_public_path__ + "static/media/features-split-top-02.dcf4f49c.png";